import { styled } from '@material-ui/core/styles'

import { BREAKPOINTS } from 'artkive/utils/constants'

export const CaptionBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    textAlign: 'center',
  },
}))
